var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuestii(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1519.79 211.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-3",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.6,93.9v111H225.3l-1.8-22.8c-21.3,17.4-52.2,29.1-93.6,29.1C40.8,211.2,0,159.9,0,104.4S40.8,0,129.9,0c67.2,0,106.8,27.9,122.4,65.1H175.5c-9.9-10.5-24.6-18.6-45.6-18.6-43.5,0-60.6,32.7-60.6,57.9s17.1,60.3,60.6,60.3c29.1,0,46.5-16.2,54.6-34.2l-40.8-3V93.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.2,6.3V130.2c0,44.1-37.8,81-119.1,81S288,174.3,288,130.2V6.3h68.1v97.8c-.6,33.3,5.4,60.6,51,60.6s51.3-26.7,51-60.6V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M773.7,6.3V52.8H626.4V81H769.2v46.5H626.4v30.9H775.2v46.5H558.3V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.5,211.2c-88.8,0-118.5-27-121.8-72h69.6c1.2,18.6,23.1,25.5,52.2,25.5s52.5-5.1,52.5-18c0-11.4-12-15-66.3-20.7C825,117.9,800.1,97.5,800.1,61.8,800.1,18.9,855.3,0,919.5,0c81.9,0,116.4,27,119.4,65.1H969.3c-.9-12.9-27.3-18.6-49.8-18.6s-49.8,3.9-49.8,14.4c0,9.9,13.8,11.4,44.4,15.3,80.1,9.6,127.5,17.4,127.5,70.5,0,33.9-27.3,64.5-122.1,64.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.3,6.3V57h-93V204.9h-68.1V57h-93V6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1350.59,6.3h68.1V204.9h-68.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1451.69,6.3h68.1V204.9h-68.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestii);
export default __webpack_public_path__ + "static/media/guestii.932e844352c273c2563553427c21d6e6.svg";
export { ForwardRef as ReactComponent };